import { Base } from "./base";
import { getAccessToken, getApp } from "../utils/browserStorage";

export class Location extends Base {
  /**
   * @description List location API function
   * @returns {Promise<Response>}
   */
  list(withMachine, fullAccess = "",parentId = "",level = "",paginationQuery = "",maxLevel = "",step ="") {
    const app = getApp() || "CGM";
    const str = withMachine
      ? `?app=${app}&withMachine=${withMachine}&fullAccess=${fullAccess}&parentId=${parentId}&level=${level}&${paginationQuery}&maxLevel=${maxLevel}&step=${step}`
      : `?app=${app}&fullAccess=${fullAccess}&parentId=${parentId}&level=${level}&${paginationQuery}&maxLevel=${maxLevel}&step=${step}`;
    const url = this._getFullURL(`/location${str}`);
    return this._secureFetch(url);
  }
  listByToken(token) {
    const app = getApp() || "CGM";
    const url = this._getFullURL(`/cmms/location-by-token?token=` + token);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  /**
   * @description Create location API function
   * @param {object} payload
   * @param fileInput
   * @returns {Promise<Response>}
   */
  create(payload, fileInput) {
    const url = this._getFullURL("/location");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("files", fileInput);

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  /**
   * @description Get location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  get(id) {
    const url = this._getFullURL(`/location/${id}`);
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Update location API function
   * @param {string} id
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  update = (id, payload, fileInput) => {
    const url = this._getFullURL(`/location`);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("files", fileInput);

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  };

  /**
   * @description Delete location API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  delete = (id) => {
    const url = this._getFullURL(`/location/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
  import(payload) {
    const url = this._getFullURL("/cmms/location-import");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
}
